/**
 * Pannello di stato non interattivo (scaduto, non disponibile, errore).
 *
 * @param {Object} props
 * @param {'neutral'|'success'|'warning'|'danger'} [props.tone] - Colore del pannello
 * @param {string} props.icon - Emoji illustrativa
 * @param {string} props.title - Titolo
 * @param {string} props.text - Spiegazione
 * @param {string} [props.hint] - Riga di chiusura, in tono minore
 */
export function StatusPanel({ tone = 'neutral', icon, title, text, hint }) {
  return (
    <div className={`gq-panel${tone === 'neutral' ? '' : ` gq-panel--${tone}`}`} role="status">
      <div className="gq-panel__icon">{icon}</div>
      <h2 className="gq-panel__title">{title}</h2>
      <p className="gq-panel__text">{text}</p>
      {hint && <p className="gq-panel__hint">{hint}</p>}
    </div>
  )
}
